import { useMainStore } from "../store/main.store";
import { isValidToken, validateToken } from "../services/CredentialsService";
import { makeLogin } from "../utils/authentication.utils";
import { useWorkflowsStore } from "../store/workflows.store";
import { Workflow } from "../interfaces/WorkflowInterface";
import { createRouter, createWebHistory } from "vue-router";

let store: any = null;
const routes = [
  {
    path: "/",
    name: "Root",
    component: () => import("../views/Main.vue"),
    meta: { requiresAuth: true },
    children: [
      { name: "d", path: "", redirect: "/home" },
      {
        path: "/home",
        name: "Home",
        component: () => import("../views/Home.vue"),

        meta: { requiresAuth: true },
        children: [
          { path: "", redirect: "/home/dashboard", name: "dashboard" },
          { path: "printJobs", component: () => import("../views/PrintJobs.vue") },
          { path: "printJobs/buckets/:bucketType", component: () => import("../views/PrintJobs.vue") },
          { path: "printJobs/history", component: () => import("../views/PrintJobsHistory.vue") },
          {
            path: "orders/:id?",
            name: "Orders",
            component: () => import("../views/Orders/OrdersHome.vue"),
          },
          {
            path: "orders/new",
            name: "NewOrder",
            component: () => import("../views/Orders/OrdersHome.vue"),
          },
          { path: "dashboard", component: () => import("../views/Dashboard.vue") },
          { path: "partnersDiscovery", component: () => import("../views/Partners/PartnersDiscover.vue") },
          { path: "incoming", component: () => import("../views/Orders/IncomingOrders.vue") },
          {
            path: "orders/workflows/:workflowId",
            component: () => import("../views/Orders/OrdersHome.vue"),
            beforeEnter: async (to: any, _from: any, next: any) => {
              const wfStore = useWorkflowsStore();
              //const ordersStore = useOrdersStore();
              // if (!wfStore.workflows.length) await wfStore.fetchAllWorkflows();
              wfStore.selectedWorkflow = wfStore.workflows.find((w: Workflow) => w.id === Number(to.params.workflowId)) || wfStore.workflows[0];
              next();
            },
          },
          {
            path: "orders/workflows/:workflowId/buckets/:bucketType",
            component: () => import("../views/Orders/OrdersHome.vue"),
          },
          {
            path: "pdf-preview",
            name: "PdfPreview",
            component: () => import("../views/PdfPreview.vue"),
          },
        ],
      },

      {
        path: "/admin",
        name: "Admin",
        component: () => import("../views/Administration/Administration.vue"),
        children: [
          {
            path: "company",
            component: () => import("../views/Administration/Company.vue"),
          },
          {
            path: "configuration",
            component: () => import("../views/Administration/Configuration.vue"),
          },
          {
            path: "users",
            component: () => import("../views/Administration/Users.vue"),
          },
          {
            path: "materials",
            component: () => import("../views/Administration/Materials.vue"),
          },

          {
            path: "printers",
            component: () => import("../views/Administration/Printers.vue"),
          },
          {
            path: "roles",
            component: () => import("../views/Administration/Roles.vue"),
          },
          { path: "apiTokens", component: () => import("../views/Administration/ApiTokens.vue") },
          { path: "partners", component: () => import("../views/Administration/Partners.vue") },
          { path: "customers", component: () => import("../views/Administration/Customers.vue") },
          { path: "services", component: () => import("../views/Administration/Services.vue") },
          { path: "workflows", component: () => import("../views/Administration/Workflows.vue") },
          { path: "orderTypes", component: () => import("../views/Administration/OrderTypes.vue") },
          { path: "orderTypes/:id", component: () => import("../views/Administration/OrderTypes.vue") },
          { path: "globalSettings", component: () => import("../views/Administration/GlobalSettings.vue") },
          { path: "customFields", component: () => import("../views/Administration/CustomFields.vue") },
          { path: "customDialogs", component: () => import("../views/Administration/CustomDialogs.vue") },
          { path: "layouts", component: () => import("../views/Administration/Layouts.vue") },
        ],
      },
    ],
  },
  {
    path: "/signup",
    name: "Signup",
    component: () => import("../views/Authentication/Signup.vue"),
    beforeEnter: [goToRoot],
  },
  {
    path: "/login",
    name: "Login",
    component: () => import("../views/Authentication/Login.vue"),
    beforeEnter: [goToRoot],
  },
  {
    path: "/finishSignup",
    name: "FinishSignup",
    component: () => import("../views/Authentication/FinishSignup.vue"),
  },
  {
    path: "/passwordReset",
    name: "PasswordReset",
    component: () => import("../views/Authentication/PasswordReset.vue"),
  },
  {
    path: "/deleteCompany",
    name: "deleteCompany",
    component: () => import("../views/Administration/DeleteCompany.vue"),
  },
  {
    path: "/forgotPassword",
    name: "ForgotPassword",
    component: () => import("../views/Authentication/ForgotPassword.vue"),
  },
  {
    path: "/inactive-company",
    name: "CompanyNotActive",
    component: () => import("../views/Authentication/CompanyNotActive.vue"),
  },
  {
    path: "/not-verified",
    name: "UserNotVerified",
    component: () => import("../views/Authentication/UserNotVerified.vue"),
  },
  {
    path: "/updateStatus",
    name: "UpdateStatus",
    component: () => import("../views/UpdateStatus.vue"),
    meta: { requiresAuth: true },
  },
  {
    path: "/acceptPartnership",
    name: "AcceptPartnership",
    component: () => import("../views/Partners/AcceptPartnership.vue"),
  },
  {
    path: "/rejectPartnership",
    name: "RejectPartnership",
    component: () => import("../views/Partners/RejectPartnership.vue"),
  },
  {
    path: "/mailSent",
    name: "MailSent",
    component: () => import("../views/Authentication/MailSent.vue"),
  },
  {
    path: "/resetOk",
    name: "ResetOk",
    component: () => import("../views/Authentication/PasswordResetFinished.vue"),
  },
  {
    path: "/start",
    name: "Start",
    component: () => import("../views/Start.vue"),
    beforeEnter: [goToRoot],
  },
  {
    path: "/verification-sent",
    name: "VerificationSent",
    component: () => import("../views/Authentication/VerificationSent.vue"),
  },
  {
    path: "/selectCompany",
    name: "selectCompany",
    component: () => import("../views/Authentication/SelectCompany.vue"),
  },
  {
    path: "/shopifyAppDemo",
    name: "ShopifyAppDemo",
    component: () => import("../views/ShopifyAppDemo.vue"),
  },
  {
    path: "/qrActions",
    props: true,
    name: "QrActions",
    meta: { requiresAuth: true },
    component: () => import("../views/QrActions.vue"),
  },
  {
    path: "/superAdmin",
    name: "SuperAdmin",
    component: () => import("../views/SuperAdmin/SuperAdmin.vue"),
    children: [
      {
        path: "companies",
        name: "Companies",
        component: () => import("../views/SuperAdmin/Companies.vue"),
        beforeEnter: (to: any, from: any, next: any) => {
          if (!hasQueryParams(to) && hasQueryParams(from)) {
            next({ path: to.path, query: from.query });
          } else {
            next();
          }
        },
      },
      {
        path: "inkTypes",
        name: "InkTypes",
        component: () => import("../views/SuperAdmin/InkTypes.vue"),
        beforeEnter: (to: any, from: any, next: any) => {
          if (!hasQueryParams(to) && hasQueryParams(from)) {
            next({ path: to.path, query: from.query });
          } else {
            next();
          }
        },
      },

      {
        path: "materialTypes",
        name: "MaterialTypes",
        component: () => import("../views/SuperAdmin/MaterialTypes.vue"),
        beforeEnter: (to: any, from: any, next: any) => {
          if (!hasQueryParams(to) && hasQueryParams(from)) {
            next({ path: to.path, query: from.query });
          } else {
            next();
          }
        },
      },
      {
        path: "services",
        name: "Services",
        component: () => import("../views/SuperAdmin/GlobalServices.vue"),
        beforeEnter: (to: any, from: any, next: any) => {
          if (!hasQueryParams(to) && hasQueryParams(from)) {
            next({ path: to.path, query: from.query });
          } else {
            next();
          }
        },
      },
      {
        path: "analytics",
        name: "SuperAdminAnalytics",
        component: () => import("../views/SuperAdmin/Analytics.vue"),
        beforeEnter: (to: any, from: any, next: any) => {
          if (!hasQueryParams(to) && hasQueryParams(from)) {
            next({ path: to.path, query: from.query });
          } else {
            next();
          }
        },
      },
    ],
  },
];
async function goToRoot(to: any, from: any, next: any) {
  const store = useMainStore();
  const token = store.userToken;
  try {
    if (token) {
      const { isValid, isActive, emailVerified } = await isValidToken(token);
      if (isValid && isActive && emailVerified) return next("/");
    }
  } catch (error) {
    return next();
  }
  return next();
}

const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes,
});

function hasQueryParams(route: any) {
  return !!Object.keys(route.query).length;
}
router.beforeEach(async (to, from, next) => {
  console.log("Navigating to:", to.fullPath);
  const requiresAuth = to.matched.some((record) => record.meta.requiresAuth);
  if (store == null) store = useMainStore();
  const token = store.userToken;
  if (to.query.goBackLink) store.goBackLink = to.query.goBackLink as string;
  if (to.query.goBackName) store.goBackName = to.query.goBackName as string;
  if (to.query.token) {
    const res = await validateToken(to.query.token as string);
    console.log("res", res);
    if (res && res.data && res.data.isValid) {
      await makeLogin(to.query.token as string, res.data.userId, false);
      const { token, ...query } = to.query;
      next({ path: to.path, query: query });
    }
  }
  if (requiresAuth) {
    try {
      const { isValid, isActive, emailVerified } = await isValidToken(token);
      if (isValid && isActive && emailVerified) next();
      else if (!isValid) {
        if (to.matched.some((record) => record.path === "/home") && !to.matched.some((record) => record.path === "/home/orders/:id?")) next("/start");
        next({
          path: "/login",
          query: { redirectTo: to.fullPath },
        });
      } else if (!emailVerified) {
        next({
          path: "/not-verified",
        });
      } else if (!isActive) {
        next({
          path: "/inactive-company",
        });
      }
    } catch (error) {
      if (to.matched.some((record) => record.path === "/home") && !to.matched.some((record) => record.path === "/home/orders/:id?")) next("/start");
      next({
        path: "/login",
        query: { redirectTo: to.fullPath },
      });
    }
  } else {
    next();
  }
});

const MAX_RETRIES = 3;
const retryCounts = new Map<string, number>();

router.onError((error, to) => {
  if (error.message.includes("Failed to fetch dynamically imported module") || error.message.includes("Importing a module script failed")) {
    console.error(`Error loading module for route: ${to.fullPath}`, error);

    const retries = retryCounts.get(to.fullPath) || 0;
    if (retries < MAX_RETRIES) {
      retryCounts.set(to.fullPath, retries + 1);

      // Add a cache-busting query parameter to force reload
      const timestamp = Date.now();
      const hasQuery = to.fullPath.includes("?");
      const newPath = `${to.fullPath}${hasQuery ? "&" : "?"}retry=${timestamp}`;
      console.log(`Retrying route (${retries + 1}/${MAX_RETRIES}): ${newPath}`);
      window.location.href = newPath;
    } else {
      retryCounts.delete(to.fullPath);
      console.warn(`Failed to load module after ${MAX_RETRIES} retries for route: ${to.fullPath}`);
      // Optionally redirect to an error page or reload the app
      window.location.reload();
    }
  }
});

export default router;
